// extracted by mini-css-extract-plugin
export default {"row":"jCHlt8gTmPyQCEbgGU7d","label":"qj9LdSHhGOX83YIiyhky","wrapped":"KV8FkMkrtvgqLnsdrG6l","bold":"oZtkoefRC0rJHtx4cJPK","subtitle":"laZRuYTOx_EQrhpZHT4t"};